"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Types_1 = require("../../../../../Types");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState || (InputValidationState = {}));
var AddSsrLocationEventContentState;
(function (AddSsrLocationEventContentState) {
    AddSsrLocationEventContentState[AddSsrLocationEventContentState["Initial"] = 0] = "Initial";
    AddSsrLocationEventContentState[AddSsrLocationEventContentState["Pending"] = 1] = "Pending";
    AddSsrLocationEventContentState[AddSsrLocationEventContentState["Success"] = 2] = "Success";
})(AddSsrLocationEventContentState || (AddSsrLocationEventContentState = {}));
var AddSsrLocationEventContent = /** @class */ (function (_super) {
    __extends(AddSsrLocationEventContent, _super);
    function AddSsrLocationEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.isValid = function (input) {
            return input === InputValidationState.valid;
        };
        _this.isInvalid = function (input) {
            return input === InputValidationState.invalid;
        };
        _this.clearValidation = function () {
            _this.setState({
                LocationNameValidationState: InputValidationState.unset,
                ClientIdValidationState: InputValidationState.unset,
                ClientSecretValidationState: InputValidationState.unset
            });
        };
        _this.validateInputs = function () {
            var isValid = true;
            if (!_this.validateInput(_this.state.LocationData.Name)) {
                _this.setState({
                    LocationNameValidationError: _this.props.applicationData.resources.ValidationError_LocationName,
                    LocationNameValidationState: InputValidationState.invalid
                });
                isValid = false;
            }
            else {
                _this.setState({
                    LocationNameValidationState: InputValidationState.valid
                });
            }
            if (!_this.validateInput(_this.state.LocationData.ClientId)) {
                _this.setState({
                    ClientIdValidationError: _this.props.applicationData.resources.ValidationError_ClientId,
                    ClientIdValidationState: InputValidationState.invalid
                });
                isValid = false;
            }
            else {
                _this.setState({
                    ClientIdValidationState: InputValidationState.valid
                });
            }
            if (!_this.validateInput(_this.state.LocationData.ClientSecret)) {
                _this.setState({
                    ClientSecretValidationError: _this.props.applicationData.resources.ValidationError_ClientSecret,
                    ClientSecretValidationState: InputValidationState.invalid
                });
                isValid = false;
            }
            else {
                _this.setState({
                    ClientSecretValidationState: InputValidationState.valid
                });
            }
            return isValid;
        };
        _this.validateInput = function (input) {
            return !(typeof input !== "string" || input === undefined || input === null || input === "");
        };
        _this.getLocationData = function () {
            return _this.state.LocationData;
        };
        _this.updateLocationData = function (event, propName) {
            var _a;
            _this.setState({
                LocationData: __assign(__assign({}, _this.state.LocationData), (_a = {}, _a[propName] = event.target.value, _a))
            });
        };
        _this.updateValidation = function (validationResponse) {
            if (validationResponse.name == "SetupLocations_CannotAddDuplicateLocations" || validationResponse.name == "SetupLocations_LocationInvalidCharacters") {
                _this.setState({
                    LocationNameValidationError: validationResponse.value,
                    LocationNameValidationState: InputValidationState.invalid
                });
            }
            if (validationResponse.name == "SetupLocations_CannotAddDuplicateClientId") {
                _this.setState({
                    ClientIdValidationError: validationResponse.value,
                    ClientIdValidationState: InputValidationState.invalid
                });
            }
        };
        _this.addLocation = function () { return __awaiter(_this, void 0, void 0, function () {
            var location, options, json, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearValidation();
                        if (!this.validateInputs()) {
                            return [2 /*return*/];
                        }
                        location = this.getLocationData();
                        this.updateModal(AddSsrLocationEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        json = JSON.stringify(location);
                        options = __assign(__assign({}, options), { body: json });
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/api/Location/Add", options).then(function (response) {
                            if (!response.ok) {
                                _this.updateModal(AddSsrLocationEventContentState.Initial);
                                response.json().then(function (validationResponse) {
                                    _this.updateValidation(validationResponse);
                                });
                            }
                            else {
                                _this.updateModal(AddSsrLocationEventContentState.Success);
                            }
                        }).catch(function (err) {
                            console.error("Error adding new location:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case AddSsrLocationEventContentState.Success:
                    if (AuthenticationService_1.Auth.getUser().Location == null || AuthenticationService_1.Auth.getUser().Location == undefined || AuthenticationService_1.Auth.getUser().Location == "undefined") {
                        sessionStorage.setItem(AuthenticationService_1.AuthenticationService.selectedLocationKey, _this.state.LocationData.Name);
                        _this.props.updateCallback(_this.state.LocationData.Name);
                    }
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case AddSsrLocationEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case AddSsrLocationEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.CreateLocation_Heading;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.SetupLocations_AddLocation, "primary", function (currentEvent, closeModalCallback) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.addLocation();
                                return [2 /*return*/];
                            });
                        }); }), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.stateBasedRender = function (currentState) {
            switch (currentState) {
                case AddSsrLocationEventContentState.Initial:
                    return (React.createElement("div", null,
                        React.createElement("div", { id: "create_location_message" },
                            _this.props.applicationData.resources.Create_Location_Part_1,
                            ' ',
                            React.createElement("a", { id: "MvpLink", target: "_blank", href: _this.props.applicationData.mvpLink }, _this.props.applicationData.resources.Create_Location_Part_2),
                            ' ',
                            _this.props.applicationData.resources.Create_Location_Part_3),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null,
                                    _this.props.applicationData.resources.Name,
                                    " ")),
                            React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.LocationNameValidationState), invalid: _this.isInvalid(_this.state.LocationNameValidationState), onChange: function (e) { return _this.updateLocationData(e, "Name"); }, value: _this.state.LocationData.Name }),
                            React.createElement(reactstrap_1.FormFeedback, null, _this.isInvalid(_this.state.LocationNameValidationState) ? _this.state.LocationNameValidationError : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null,
                                    _this.props.applicationData.resources.ClientId,
                                    " ")),
                            React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.ClientIdValidationState), invalid: _this.isInvalid(_this.state.ClientIdValidationState), onChange: function (e) { return _this.updateLocationData(e, "ClientId"); }, value: _this.state.LocationData.ClientId }),
                            React.createElement(reactstrap_1.FormFeedback, null, _this.isInvalid(_this.state.ClientIdValidationState) ? _this.state.ClientIdValidationError : "")),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null,
                                    _this.props.applicationData.resources.ClientSecret,
                                    " ")),
                            React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.ClientSecretValidationState), invalid: _this.isInvalid(_this.state.ClientSecretValidationState), onChange: function (e) { return _this.updateLocationData(e, "ClientSecret"); }, value: _this.state.LocationData.ClientSecret }),
                            React.createElement(reactstrap_1.FormFeedback, null, _this.isInvalid(_this.state.ClientSecretValidationState) ? _this.state.ClientSecretValidationError : ""))));
                case AddSsrLocationEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case AddSsrLocationEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.props.applicationData.resources.AddLocationSuccessMessage),
                            React.createElement(reactstrap_1.Col, null))));
            }
        };
        _this.state = {
            LocationNameValidationState: InputValidationState.unset,
            ClientIdValidationState: InputValidationState.unset,
            ClientSecretValidationState: InputValidationState.unset,
            LocationNameValidationError: "",
            ClientIdValidationError: "",
            ClientSecretValidationError: "",
            LocationData: {},
            showOverlay: false,
            status: AddSsrLocationEventContentState.Initial
        };
        return _this;
    }
    AddSsrLocationEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return AddSsrLocationEventContent;
}(React.Component));
exports.AddSsrLocationEventContent = AddSsrLocationEventContent;
//# sourceMappingURL=AddSsrLocationEventContent.js.map